export default __webpack_public_path__ + "static/media/BagRed.27808d70.png";